<template>
  <div class="error-page container">
    <p v-if="$route.params.code"><small>Code erreur : {{ $route.params.code }}</small></p>
    <p v-else><small>Code erreur : 404</small></p>
    <p> La page que vous recherchez est introuvable.</p>
  </div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  },
  methods: {
    
  },
  created () {
    let codes = [ '404', '400', '500', '100' ]
    let error = codes.find(c => c == this.$route.params.code)
    if(!error)
      this.$router.push({ name: 'error', params: { code: '404' } })
  }
}
</script>

<style lang="scss">
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.error-page {
  background-color: #F5F5F5;
  width: 100%;
  padding: 45px 0 35px;

  @include min($lg) {
    padding: 83px 0 75px;
  }
}
</style>
